import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export const SubscribeForm = ({ source = "", className = "" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: "loading", message: "" });
    try {
      const res = await api.post("/subscribe", { email, source });
      setState({ status: res.data.status, message: res.data.message });
      if (res.data.status === "subscribed") setEmail("");
    } catch (err) {
      setState({ status: "error", message: formatApiErrorDetail(err.response?.data?.detail) });
    }
  };

  const msgColor = state.status === "error" ? "text-red-400" : state.status === "exists" ? "text-amber-300" : "text-emerald-400";

  return (
    <section data-testid="subscribe-form-section" className={`rounded-xl bg-[#1C1C1F] border border-white/10 px-5 py-4 sm:px-6 flex flex-col md:flex-row md:items-center gap-3 md:gap-6 ${className}`}>
      <div className="md:shrink-0">
        <h2 className="font-display font-bold text-base sm:text-lg text-white tracking-tight leading-tight">Never miss a drop</h2>
        <p className="text-xs sm:text-sm text-gray-400 mt-0.5">Free episode updates, straight to your inbox.</p>
      </div>
      <div className="flex-1 min-w-0">
      <form onSubmit={submit} className="flex flex-row gap-2">
        <input
          data-testid="subscribe-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 rounded-full bg-[#111113] border border-white/10 px-4 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-[#FF7A1A]/70 transition-colors"
        />
        <button
          data-testid="subscribe-submit-btn"
          type="submit"
          disabled={state.status === "loading"}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#FF7A1A] hover:bg-[#FF8D3A] active:scale-[0.98] text-black font-semibold text-sm px-5 py-2 shrink-0 transition-[background-color,transform] disabled:opacity-60"
        >
          {state.status === "loading" && <Loader2 className="w-4 h-4 animate-spin" />} Subscribe
        </button>
      </form>
      {state.message && (
        <p data-testid="subscribe-message" className={`mt-1.5 text-xs ${msgColor}`}>{state.message}</p>
      )}
      </div>
    </section>
  );
};
